import { defaults as lodashDefaults } from 'lodash';
export function defaults(sourceProps, destinationProps) {
    return lodashDefaults(sourceProps, destinationProps);
}
